export let charBank = {
    1: "asdf",
    2: "jkl;",
};

charBank[3] = charBank[1] + charBank[2];
charBank[4] = charBank[3] + "gh";
charBank[5] = charBank[4] + "'";
charBank[6] = charBank[5] + ':"';
charBank[7] = charBank[6] + "qwert";
charBank[8] = charBank[7] + "yuiop";
charBank[9] = charBank[8] + "zxcvb";
charBank[10] = charBank[9] + "nm,.?";
charBank[11] = charBank[10] + "12345";
charBank[12] = charBank[11] + "67890";
charBank[13] = charBank[12] + "!@#$%^&*()_+-=";
charBank[14] = charBank[13] + "<>/{}|[]\\";
